/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartVennRight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M9 5a1 1 0 1 1 0 2 5 5 0 0 0 0 10 1 1 0 0 1 0 2A7 7 0 0 1 9 5zm6 0c3.86 0 7 3.141 7 7s-3.14 7-7 7c-.599 0-1.316-.144-2.129-.413C14.805 17.124 16 14.646 16 12s-1.195-5.124-3.129-6.587C13.684 5.144 14.401 5 15 5zm-3 2.262c1.248 1.116 2 2.87 2 4.738s-.752 3.622-2 4.737c-1.248-1.115-2-2.868-2-4.737s.752-3.622 2-4.738z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartVennRight as ChartVennRight };
